export default __webpack_public_path__ + "static/media/saluteTr.d1ba238c.svg";